import gql from 'graphql-tag'

export const RENEW_TOKEN_MUTATION = gql`
  mutation RenewToken($refreshToken: String) {
    renewToken(refreshToken: $refreshToken) {
      ... on RenewSuccess {
        __typename
        accessToken
        refreshToken
        locationToken
      }
      ... on UnauthorizedError {
        error {
          code
          message
        }
      }
    }
  }
`
